export default __webpack_public_path__ + "static/media/offer__sell.6ee6d5f3.jpg";